import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import LazyImage from "../../shared/lazy-image";
import { DisplayText } from "@cars24/turbo-web/lib/display-text";
import { Text } from "@cars24/turbo-web/lib/text";

const EChallanEasySteps = ({
    howToPayChallanData
}) => {

    const {
        title = "",
        howToPayChallanList = []
    } = howToPayChallanData || {};

    const { tokens } = useTokens();

    return (
        <div styleName={"styles.easyStepsWrapper"}>
            <div styleName={"styles.easyStepsHeader"}>
                <Text size="450" fontWeight="semibold" as="h2" color={tokens.text_default_text_primary}>{title}</Text>
            </div>
            <div styleName={"styles.easyStepsTab"}>
                {
                    howToPayChallanList.length > 0 && howToPayChallanList.map((item, index) => {
                        return (
                            <div key={item?.id} styleName={"styles.easyStepsTabWrapper"}>
                                <div styleName={"styles.easyTabImageWrapper"}>
                                    <LazyImage src={item?.image?.url} alt={item?.image?.alternativeText} width={293} height={164} />
                                    <DisplayText color={tokens.text_brand_text_brand} isBold>0{index + 1}</DisplayText>
                                </div>
                                <div styleName={"styles.easyStepsTabContent"}>
                                    <Text size="300" fontWeight="semibold" color={tokens.text_default_text_primary}>{item?.title}</Text>
                                    <Text size="250" fontWeight="regular" color={tokens.text_default_text_secondary}>{item?.description}</Text>
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
};

EChallanEasySteps.propTypes = {
    howToPayChallanData: PropTypes.object
};

export default EChallanEasySteps;
